export default "__VITE_ASSET__19e751ed__"